export default {
    "id": "finddoc-care",
    "name": "FindDoc Care",
    "style": "link",
    "href": "https://www.finddoc.com/patient-care"
}